import React from 'react';
import { useTranslation } from 'react-i18next';

import Cta from 'component/Layout/Cta';

import { ReactComponent as IconInfoCircle } from 'media/svg/infoCircle.svg';

import styles from '../List.module.scss';

const OutOfService = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.OutOfService}>
            <IconInfoCircle />
            {t('TRANS-data-providers-overloaded')}
            <br />
            <b>{t('TRANS-try-it-again-in-few-minutes')}</b>
            <Cta
                customClassList={{ Cta: styles.Cta }}
                onClick={() => location.reload()}
            >
                {t('TRANS-reload-page')}
            </Cta>
        </div>
    );
};

export default OutOfService;
